"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _prop = require("ramda/src/prop");

var _prop2 = _interopRequireDefault(_prop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var inner = (0, _glamor.css)({
  position: "relative"
});

var error = (0, _glamor.css)({
  position: "absolute",
  left: 0,
  marginTop: "1em",
  fontSize: "0.875em",
  color: _css.colors.red
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  right: 0,
  left: "unset"
}));

var message = (0, _glamor.css)(error, {
  color: _css.colors.blue + " !important"
});

var Form = function Form(props) {
  return _react2.default.createElement(
    "form",
    {
      id: props.id,
      className: props.className,
      onSubmit: props.onSubmit,
      ref: props.onChildRef,
      method: "post",
      autoComplete: props.autoCompleteProp
    },
    _react2.default.createElement(
      "div",
      { className: inner },
      props.children,
      props.error && _react2.default.createElement(
        "span",
        { className: error },
        props.error
      ),
      props.message && _react2.default.createElement(
        "span",
        { className: message },
        props.message
      )
    )
  );
};

exports.default = Form;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/Form.jsx
// module id = 2593
// module chunks = 0